jQuery(document).ready(function() {
  $('#list_partner_savings-datatable').DataTable({
    "processing": true,
    "serverSide": true,
    "pageLength": 50,
    "ajax": {
      "url": $('#list_partner_savings-datatable').data('source')
    },
    "language": {
      "info": "Viendo _START_ de _END_ de _TOTAL_ registros",
      "infoEmpty": "Viendo 0 a 0 de 0 registros",
      "search": "Buscar",
      "lengthMenu": "Ver _MENU_ registros",
      "paginate": {
        "first":      "Primera",
        "last":       "Última",
        "next":       "Siguiente",
        "previous":   "Anterior"
      }
    },
    "pagingType": "simple_numbers",
    "columns": [
      {"data": "folio"},
      {"data": "no_nomina"},
      {"data": "last_name"},
      {"data": "amount"},
      {"data": null,
        "render": function(data){
          if (data.status == "true"){
            return "<center><i class='fas fa-dollar-sign' style='color: green;'/></center>"
          } else {
            return "<center><i class='fas fa-dollar-sign' style='color: red;'/></center>"
          }
        }
      }
    ]
  });
});
